module.exports = __webpack_public_path__ + "img/073698.486d3c55.png";